import { tv } from 'tailwind-variants';

export const linkStyle = tv({
  base: 'text-white font-semibold flex items-center gap-x-2',
  variants: {
    textTransform: {
      uppercase: 'uppercase',
      capitalize: 'capitalize',
      lowercase: 'lowercase',
      none: '',
    },
    design: {
      buttonPrimary:
        'bg-primary-one text-white px-8 w-fit justify-center rounded-lg hover:brightness-75',
      buttonSecondary:
        'bg-secondary-one text-white px-8 w-fit justify-center rounded-lg hover:brightness-75',
      buttonSecondaryDark:
        'bg-secondary-two text-white px-8 w-fit justify-center rounded-lg hover:brightness-75',
      outline: 'bg-transparent border border-secondary-two hover:opacity-60',
      'icon-only': 'bg-transparent text-[0] hover:opacity-60',
      transparent: 'bg-transparent rounded-md hover:opacity-60',
      custom: 'hover:bg-opacity-70',
    },
    hoverVariant: {
      underline: 'hover:underline',
      saturate: 'hover:saturate-[0.8]',
      brightness: ' hover:brightness-75',
      opacity: 'hover:opacity-60',
      none: 'hover:none',
    },
    size: {
      xs: 'h-6 text-xs',
      sm: 'h-8 text-xs',
      md: 'h-10',
      lg: 'h-12',
    },
  },
  defaultVariants: {
    design: 'transparent',
    hoverVariant: 'underline',
    textTransform: 'capitalize',
    size: 'md',
  },
});
